// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2efH5","select":"Header_select__3E15w","clinic":"Header_clinic__3nib9"};